import React, { useState } from "react";
import axios from "axios";
import {
  Upload,
  Button,
  message,
  Typography,
  Input,
  Image,
  Select,
} from "antd"; // Added Select
import { UploadOutlined } from "@ant-design/icons";
import { API_BASE_URL } from "../config/apiConfig";
import { useTranslation } from "react-i18next";
import HomeButton from "../components/HomeButton";

const { Title } = Typography;
const { Option } = Select;

const ImageCaptioning: React.FC = () => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [caption, setCaption] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState<string>("EN");

  const { t } = useTranslation();

  const handleFileUpload = async (file: File) => {
    // if (file.type !== "image/png") {
    //   message.error("Only PNG images are allowed.");
    //   return;
    // }

    setLoading(true);
    setCaption(null);

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = async () => {
      const base64String = reader.result?.toString().split(",")[1];

      setImageUrl(URL.createObjectURL(file));

      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${API_BASE_URL}/zhadiger/api/image/captioning`,
          {
            text: base64String,
            lang: language,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${token}`,
            },
          }
        );

        setCaption(response.data);
        message.success("Image caption retrieved successfully!");
      } catch (error) {
        message.error("Failed to retrieve image caption.");
        console.error("Error in image captioning API:", error);
      } finally {
        setLoading(false);
      }
    };

    reader.onerror = () => {
      message.error("Failed to read file.");
      setLoading(false);
    };
  };

  return (
    <>
      <div className="flex justify-between items-center mb-4 ml-4 mt-4">
        <HomeButton />
      </div>
      <div className="max-w-[70%] mx-auto mt-10 p-6 bg-white border border-gray-200 rounded-lg shadow-md">
        <Title level={2} className="text-center font-bold text-gray-700">
          {t("image_captioning")}
        </Title>

        <div className="text-center mt-4">
          <Select
            value={language}
            onChange={(value) => setLanguage(value)}
            className="w-40"
          >
            <Option value="EN">{t("english")}</Option>
            <Option value="KZ">{t("қазақша")}</Option>
          </Select>
        </div>

        <div className="flex flex-col md:flex-row md:space-x-4 mt-6">
          <div className="w-full md:w-1/2 p-4 bg-white border border-gray-200 rounded-lg shadow-md text-center">
            <Upload
              beforeUpload={(file) => {
                setLoading(true);
                handleFileUpload(file);
                return false;
              }}
              accept=".png, .jpg, .jpeg"
              maxCount={1}
              showUploadList={false}
            >
              <Button icon={<UploadOutlined />} loading={loading}>
                {t("upload_image")}
              </Button>
            </Upload>

            {imageUrl && (
              <div className="mt-6">
                <Title level={4} className="text-gray-600">
                  {t("uploaded_image")}
                </Title>
                <Image src={imageUrl} alt="Uploaded Image" width={300} />
              </div>
            )}
          </div>

          <div className="w-full md:w-1/2 p-4 bg-white border border-gray-200 rounded-lg shadow-md">
            <Title level={4} className="text-gray-600 text-center">
              {t("generated_caption")}:
            </Title>
            <Input.TextArea
              value={caption || t("generated_text_placeholder") || ""}
              readOnly
              rows={4}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ImageCaptioning;
